import * as alasql from 'alasql'
import { operations } from './operations'
import * as queryResultFormatting from './query-result-formatting'
import { maxBy } from 'lodash';

const paginate = require("paginate-array");
const TOTALS_KEY = 'totals';

function camelize(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '');
}

export function getPivot(dataProvider, dataOptions = {}, dataGridOptions = {}, sqlQuery = "", itemsPerPage = 100, numOfPage = 1) {
  const getGridDataset = $getGrid(dataProvider);

  let data;
  if (getGridDataset.length > 1000) {
    const paginateCollection = paginate(getGridDataset, numOfPage, itemsPerPage);
    data = paginateCollection.data
  } else if (getGridDataset.length !== 0) {
    data = getGridDataset
  } else {
    data = []
  }

  data.forEach(item => {
    Object.keys(item).map((k) => {
      if (item[`$${k}$display`]) {
        item[k] = item[`$${k}$display`];
      }
    })
  })
  
  const additionalFields = {}
  Object.values(dataGridOptions[dataProvider].meta).map(field => {
    additionalFields[camelize(field.displayName)] = null
    if (field.type == 'date') {
      additionalFields['[$'+camelize(`${field.displayName}$YearWeek`)+']'] = null
      additionalFields['[$'+camelize(`${field.displayName}$Month`)+']'] = null
      additionalFields['[$'+camelize(`${field.displayName}$Year`)+']'] = null
      additionalFields['[$'+camelize(`${field.displayName}$Date`)+']'] = null
      additionalFields['[$'+camelize(`${field.displayName}$MonthYear`)+']'] = null
      additionalFields['$count'] = null
    }
  })

  const pivotData = formPivotDataFromRow(additionalFields, dataOptions);
  const query = (sqlQuery == null || sqlQuery.length === 0) ? genSQLFromPivotData(pivotData) : sqlQuery;

  let queryResult = [];
  try {
    queryResult = alasql(query, [data]);
  } catch(e) {
    console.log('error is', e, query)
  }

  const rows = queryResult.length > 0 ? getFormattingRows(queryResult, pivotData) : [];
  const calculatedRows = rows.length > 0 ? calculateRows(rows, pivotData.currentOperation) : [];
  if (pivotData.highlightAsHeatmap) {
    fillCellsWithHeatmap(calculatedRows);
  }
  
  const plainRows = getPlainRows(calculatedRows);
  const totalItems = getGridDataset.length

  const result = { ...pivotData, rows: calculatedRows, plainRows, query, totalItems }

  return result;
}

function formPivotDataFromRow(item = {}, dataOptions) {
  const itemFields = Object.keys(item || {})
    //.filter(key => !key.match(/^\$/))
    .map((key) => ({
      getter: item => item[key],
      key: key,
      label: key
    }));

  let rowFields;
  let colFields;

  if (dataOptions.rowFields) {
    rowFields = itemFields.filter(field => dataOptions.rowFields.includes(field.label));
    rowFields = dataOptions.rowFields.map(key => rowFields.find(rowField => rowField.key === key));
  } else {
    rowFields = itemFields.splice(0, 1);
  }

  if (dataOptions.columnFields) {
    colFields = itemFields.filter(field => dataOptions.columnFields.includes(field.label));
    colFields = dataOptions.columnFields.map(key => colFields.find(colField => colField.key === key));
  } else {
    colFields = [];
  }

  const fields = itemFields.filter(field => !rowFields.includes(field) && !colFields.includes(field))
  const calcColumnsKeys = Object.keys(item).filter(key => !Number.isNaN(+item[key]));
  const calcColumns = calcColumnsKeys.map(key => ({name: key, expression: key}));
  calcColumns.push({name: 'Expression', expression: `$count + 1`});
  let currentCalcColumn = dataOptions.calcColumn || calcColumns[0];
  currentCalcColumn = typeof currentCalcColumn === 'string' ? {key: currentCalcColumn, expression: currentCalcColumn} : currentCalcColumn;
  const currentOperation = dataOptions.operation ? operations.find(operation => operation.label === dataOptions.operation) : operations[0];
  const showSettings = 'showSettings' in dataOptions ? dataOptions.showSettings : true;
  const showFilterSettings = 'showFilterSettings' in dataOptions ? dataOptions.showFilterSettings : false;
  const highlightAsHeatmap = 'highlightAsHeatmap' in dataOptions ? dataOptions.highlightAsHeatmap : false;
  const conditionGroup = dataOptions.conditionGroup || {condition: ' AND ', rules: []};
  return { 
    rowFields, colFields, fields, calcColumns, currentCalcColumn, currentOperation, 
    operations, showSettings, conditionGroup, showFilterSettings, highlightAsHeatmap
  };
}


function genSQLFromPivotData({colFields, rowFields, currentCalcColumn, currentOperation, conditionGroup}) {
  const getItemValue = item => `${item.key}`;
  const genSequnceString = list => list.map(getItemValue).join(', ');
  const [colField] = colFields;
  const calcColumn = currentCalcColumn ? currentCalcColumn.expression.replace(/([$\w]+)([\w\d$-_]+)/ig, "[$1$2]::NUMBER") : '';
  const queryRowFields = genSequnceString(rowFields);

  const queryConditionString = createQueryCondition(conditionGroup);
  if (!colField) {
    const querySelectString = queryRowFields || '*';
    const queryGroupString = queryRowFields ? `GROUP BY ${queryRowFields}` : '';
    const querySortString = queryRowFields ? `ORDER BY ${queryRowFields}` : '';
    const operationField = (calcColumn && queryRowFields) ? `, ${currentOperation.operation}(${calcColumn})  AS totals`: '';
    return `SELECT ${querySelectString} ${operationField} FROM ? ${queryConditionString} ${queryGroupString} ${querySortString}`;
  } else {
    const querySelectString = queryRowFields ? `${queryRowFields},` : '';
    const colFieldValue = getItemValue(colField);
    const cellTotalField = calcColumn ? `, (${calcColumn})  AS totals`: '';
    return `SELECT ${querySelectString} ${colFieldValue} ${cellTotalField}  FROM ? PIVOT (${currentOperation.operation}(totals) FOR ${colFieldValue}) ${queryConditionString} `;
  }
}

function createQueryCondition(conditionGroup) {
  conditionGroup = filterEmptyRules(conditionGroup);
  let query = buidConditionString(conditionGroup);

  query = query.replace('"true"', 'true')
  query = query.replace('"false"', 'null')

  return query ? ` WHERE ${query}` : '';
}

function buidConditionString(conditionGroup) {
  return (conditionGroup.rules || []).map((rule) => {
    if (rule.condition) {
      return `(${buidConditionString(rule)})`;
    } else if(rule.operator === 'in') {
      return `[${rule.key}] IN (${getRuleValueString(rule.value)})`;
    } else {
      return `[${rule.key}]${rule.operator}${getRuleValueString(rule.value)}`;
    }
  }).join(` ${conditionGroup.condition} `)
}

function getRuleValueString(value) {
  const formattValue = (item) => `${(item.name || item)}`.replace('"', '\"');
  return `"${Array.isArray(value) ? value.map(i => formattValue(i)).join('", "') : formattValue(value)}"`;
}

function filterEmptyRules(conditionGroup) {
  const isNotEmptyRule = (rule) => rule.key !== -1 && rule.operator !==-1 && (Array.isArray(rule.value) ? rule.value.length > 0 : !!rule.value);
  return {
    ...conditionGroup,
    rules: (conditionGroup.rules || []).reduce((rules, rule) => {
      if (rule.condition) {
        rule = filterEmptyRules(rule);
        if (rule.rules.length > 0) {
          rules.push(rule);
        }
      } else if (isNotEmptyRule(rule)) {
        rules.push(rule);
      }

      return rules;
    }, [])
  };
}

function getFormattingRows(rows, { rowFields, colFields, fields}) {
  if (colFields.length > 0 && rowFields.length) {
    rows = queryResultFormatting.addEmptyColumns(rows, rowFields, fields);
  }
  rows = queryResultFormatting.addRowsTotals(rows, rowFields, fields);
  rows = queryResultFormatting.addColumnsTotals(rows, rowFields, fields);

  return queryResultFormatting.formattingRows(rows, rowFields, fields);
}


function calculateRows(rows, operation) {
  const rowTotals = rows[rows.length - 1];
  const calcCell = (cell, colIndex, rowIndex) => {
    const rowTotal = getTotalsValue(rows[rowIndex]);
    const colTotals = rowTotals[colIndex].value;
    const totals = getTotalsValue(rowTotals);
    return operation.cellGetter(cell.value, rowTotal, colTotals, totals);
  };
  return rows.map((row, rowIndex) => {
    return [...row.map((cell, colIndex) => ({
      ...cell,
      currentValue: cell.value,
      value: cell.calculated ? calcCell(cell, colIndex, rowIndex) : cell.value
    }))]
  });
}

function getPlainRows(rows) {
  return rows.map((row) => {
    return row.reduce((item, cell) => ({...item, [cell.key]: cell.value}), {});
  });
}

function fillCellsWithHeatmap(rows) {
  const maxValue = getRowsMaxValue(rows);
  rows.forEach((row) => {
    row.forEach((cell) => {
      if (cell.calculated) {
        cell.colorOffset = 255 - Math.min(255, Math.max(0, Math.round(255 * cell.currentValue / maxValue)));
      }
    });
  })
}

function getRowsMaxValue(rows) {
  const findCellMaxValue = (row) => {
    const val = maxBy(row.filter(c => !isTotalsCell(c) && !Number.isNaN(+c.currentValue)), 'currentValue');
    return val && val.currentValue;
  };
  const row =  maxBy(rows, findCellMaxValue);
  return row ? findCellMaxValue(row) || [] : [];
}

function getTotalsValue(items) {
  return findTotals(items).value;
}

function findTotals(items) {
  return items.find(isTotalsCell);
}

function isTotalsCell(cell) {
  return cell.key === TOTALS_KEY
}